module.exports = __webpack_public_path__ + "img/jafmob.f1d571b7.png";